import { createSlice } from '@reduxjs/toolkit';

const myIncidentsFilterSlice = createSlice({
    name: 'myIncidentsFilter',
    initialState: {
        isLoading: false,
        isError: false,
        error: false,
        isFetched: false,
        getAllRefStatus: [],
    },
    reducers: {
        fetchAllRefStatusOption: (state, action) => {
            state.getAllRefStatus = action.payload;
            state.isLoading = false;
            state.isFetched = true;
        },
        fetchAllRefStatusOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
            state.isFetched = false;
        },
    },
});

export const {
    fetchAllRefStatusOption,
    fetchAllRefStatusOptionError,
} = myIncidentsFilterSlice.actions;

export default myIncidentsFilterSlice.reducer;